import {BRANDS, LOGIN_CASES} from 'const'
import config from 'config'
import {getDefaultConfig, getFooterLogosByBrandList} from '../commonHelper'

export default {
  brand: {
    name: BRANDS.testing,
    url: 'https://blick.ch/',
    favicon: `${config.url}/assets/testing-favicon.ico`,
    fontColor: '#000000',
  },
  config: {
    ...getDefaultConfig(),
    marketingOnePager: ({loginCase}) => loginCase === LOGIN_CASES.EMAIL_ONLY,
    newsletterOnePager: true,
    admeiraOptInOnePager: true,
    marketingConsent: true,
    onePager: ({loginCase}) => LOGIN_CASES.EMAIL_ONLY === loginCase,
  },
  fontConfig: {
    custom: {
      urls: [`${config.url}/fonts/blick/index.css`, `${config.url}/fonts/common/index.css`],
    },
  },
  font: {
    family: "'Source Sans Pro', Helvetica, Arial, sans-serif",
    boldFamily: "'Source Sans Pro SemiBold', Helvetica, Arial, sans-serif",
    boldFontWeight: '700',
    size: '14px',
    height: '16px',
    mobile: {
      size: '16px',
      height: '22px',
    },
    portrait: {
      size: '18px',
      height: '23px',
    },
    color: {
      dark: '#000000',
      light: '#ffffff',
    },
  },
  secondaryFont: {
    size: '14px',
    height: '16px',
    mobile: {
      size: '16px',
      height: '22px',
    },
    portrait: {
      size: '16px',
      height: '22px',
    },
  },
  title: {
    family: "'HeronSansCond Bold', Helvetica, Arial, sans-serif",
    size: '32px',
    height: '30px',
    mobile: {
      size: '52px',
      height: '54px',
    },
    portrait: {
      size: '52px',
      height: '54px',
    },
  },
  ringierBanner: {
    fontSize: '16px',
    lineHeight: '24px',
    benefitsIcon: `${config.url}/assets/BLICK-icon-check-banner.svg`,
    backgroundColor: '#F8F8F8',
    linkColor: '#545454',
    linkHoverColor: '#FF0000',
    benefitMessageColor: '#1F1F1F',
    titleFamily: "'HeronSans SemiBold', Helvetica, Arial, sans-serif",
    messageFamily: "'Source Sans Pro', Helvetica, Arial, sans-serif",
    iconWidth: '24px',
    iconHeight: '24px',
    landscape: {
      fontSize: '16px',
    },
  },
  otherBrandsLogos: getFooterLogosByBrandList([BRANDS.energy, BRANDS.schweizerillustrierte, BRANDS.blick, BRANDS.cash]),
  note: {
    family: "'HeronSans SemiBold', Helvetica, Arial, sans-serif",
  },
  background: {
    light: '#ffffff',
    dark: ' #47484a',
  },
  notification: {
    family: "'Source Sans Pro', Helvetica, Arial, sans-serif",
    success: '#00d523',
    error: '#E2001A',
    pageError: '#000000',
    warning: '#FFB120',
    info: '#5DB4FF',
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '16px',
      height: '22px',
      sizeMobile: '14px',
      heightMobile: '20px',
    },
  },
  buttons: {
    height: '50px',
    primary: {
      border: '1px solid #E2001A',
      color: '#ffffff',
      background: '#E2001A',
      hoverBorder: '1px solid #FF0000',
      hoverBackground: '#FF0000',
      activeBorder: '1px solid #000000',
      activeBackground: '#000000',
    },
    secondary: {
      border: '1px solid #919191;',
      color: '#E2001A',
      background: '#FFFFFF',
      hoverBorder: '1px solid #FF0000',
      hoverColor: '#FF0000',
      hoverBackground: '#FFFFFF',
      activeBorder: '1px solid #000000',
      activeColor: '#000000',
      activeBackground: '#FFFFFF',
      dotsColor: '#E2001A',
    },
    disabled: {
      border: '1px solid #F8F8F8',
      color: '#919191',
      background: '#F8F8F8',
      hoverBorder: null,
      hoverBackground: '#F8F8F8',
      activeBorder: null,
      activeBackground: '#F8F8F8',
    },
    swiss: {
      border: '1px solid #E2001A',
      color: '#ffffff',
      background: '#E2001A',
      hoverBorder: '1px solid #FF0000',
      hoverBackground: '#FF0000',
      activeBorder: '1px solid #000000',
      activeBackground: '#000000',
      icon: 'icon-SwissID-24x24.svg',
      iconStyles: {},
    },
    apple: {
      border: '1px solid #B8C2CB',
      color: '#000000',
      background: '#FFFFFF',
      hoverBorder: '1px solid #FF0000',
      hoverColor: '#FF0000',
      activeBorder: '1px solid #000000',
      activeColor: '#000000',
      icon: 'logo-apple-black.svg',
    },
    facebook: {
      border: '1px solid #B8C2CB',
      color: '#365899',
      background: '#FFFFFF',
      hoverBorder: '1px solid #FF0000',
      hoverColor: '#FF0000',
      activeBorder: '1px solid #000000',
      activeColor: '#000000',
      icon: 'icon-facebook-24x24.svg',
    },
    google: {
      border: '1px solid #B8C2CB',
      color: '#DC4E41',
      background: '#FFFFFF',
      hoverBorder: '1px solid #FF0000',
      hoverColor: '#FF0000',
      activeBorder: '1px solid #000000',
      activeColor: '#000000',
      icon: 'icon-google-24x24.svg',
    },
    touchId: {
      border: '1px solid #E2001A',
      color: '#ffffff',
      background: '#E2001A',
      hoverBorder: '1px solid #FF0000',
      hoverBackground: '#FF0000',
      activeBorder: '1px solid #000000',
      activeBackground: '#000000',
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    faceId: {
      border: '1px solid #E2001A',
      color: '#ffffff',
      background: '#E2001A',
      hoverBorder: '1px solid #FF0000',
      hoverBackground: '#FF0000',
      activeBorder: '1px solid #000000',
      activeBackground: '#000000',
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '12px', marginLeft: '5px'},
    },
    anyId: {
      border: '1px solid #E2001A',
      color: '#ffffff',
      background: '#E2001A',
      hoverBorder: '1px solid #FF0000',
      hoverBackground: '#FF0000',
      activeBorder: '1px solid #000000',
      activeBackground: '#000000',
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: "'HeronSans SemiBold', Helvetica, Arial, sans-serif",
      color: '#000000',
      size: '16px',
    },
    border: {
      size: '1px',
      radius: '100px',
    },
  },
  link: {
    default: '#E2001A',
    hoverColor: '#FF0000',
    secondary: '#545454',
    secondaryHover: '#FF0000',
    agreement: '#000000',
    isAgreementsLink: true,
  },
  logisterSection: {
    subheaderPadding: '12px 20px',
    subheaderFontSize: '16px',
    subheaderLineHeight: '24px',
    subheaderTitleColor: '#000000',
    subheaderLinkColor: '#545454',
    subheaderLinkHoverColor: '#FF0000',
    subheaderBackgroundColor: '#F8F8F8',
    noteFontSize: {
      default: '12px',
      portrait: '14px',
    },
    title: {
      textChangeBreakpoint: 'portrait',
      fontSize: {
        smallMobile: '30px',
        mobile: '30px',
        portrait: '36px',
        landscape: '40px',
        desktop: '40px',
      },
      lineHeight: {
        smallMobile: '32px',
        mobile: '32px',
        portrait: '44px',
        landscape: '44px',
        desktop: '44px',
      },
    },
  },
  form: {
    border: '1px solid #f1f1f1',
    background: '#f8f8f8',
    fieldBackground: '#f8f8f8',
    padding: '20px 20px 16px 20px',
    sectionViewBackground: '#f8f8f8',
    loginSubmitMarginTop: '20',
    marginBottom: '8px',
  },
  logisterForm: {
    border: '1px solid #f1f1f1',
    background: '#f8f8f8',
    padding: '20px',
    landscapePadding: '40px',
    submitButton: 'primary',
    forgetLinkFloat: '',
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 20px',
      portrait: '0 0 20px',
    },
    titleMargin: {
      default: '0 0 20px',
      portrait: '0 0 20px',
    },
    submitButtonMarginTop: 20,
  },
  emailVerifyPage: {},
  field: {
    error: {
      background: '#e2001a',
      fontColor: '#ffffff',
      size: '16px',
      height: '24px',
    },
    label: {
      color: '#000000',
      disabledColor: '#000000',
      family: "'HeronSans SemiBold', Helvetica, Arial, sans-serif",
      fontSize: '16px',
      fontHeight: '22px',
      bottomMargin: '16px',
    },
    edging: {
      backgroundColor: '#F8F8F8',
    },
    optional: {
      family: "'Source Sans Pro', Helvetica, Arial, sans-serif",
    },
  },
  input: {
    border: '1px solid #919191',
    focusBorder: '1px solid #000000',
    hoverBorder: '1px solid #000000',
    height: '40px',
    email: {
      backgroundColor: '#F8F8F8',
      border: '1px solid #919191',
      button: {
        height: '40px',
        right: '0px',
        backgroundColor: '#F8F8F8',
        color: '#E2001A',
        fontSize: '14px',
        textDecoration: 'underline',
        border: '1px solid #919191',
        borderRight: '0',
        hoverColor: '#FF0000',
        hoverBorder: '1px solid #919191',
        hoverBorderRight: '0',
      },
    },
    password: {
      color: '#919191',
      hoverColor: '#000000',
      size: '14px',
      height: '22px',
      top: '10px',
    },
    loading: {
      top: '7px',
    },
  },
  checkbox: {
    icon: {
      height: '16px',
      width: '16px',
      top: '3px',
      right: '12px',
      image: 'NB-form-checkbox.svg',
      checkedImage: 'form-checkbox-checked.svg',
      hoverImage: 'NB-form-checkbox-hover.svg',
      errorImage: 'form-checkbox-error.svg',
      disabledImage: 'NB-form-checkbox.svg',
    },
    errorMargin: '20px -20px -16px',
    padding: '20px',
    labelFontHeight: '22px',
    errorPadding: '4px 20px 0',
    group: {
      label: {
        marginBottom: '0',
        padding: '20px 0 0 20px',
        backgroundColor: '#f6f6f6',
      },
      fontSize: '16px',
      marginBottom: '8px',
      padding: '0 20px',
      backgroundColor: '#f6f6f6',
      note: {
        fontSize: '14px',
        marginLeft: '28px',
      },
    },
  },
  select: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'from-arrow-down.svg',
      focusImage: 'from-arrow-down.svg',
      alt_image: 'from-arrow-down.svg',
    },
    menu: {
      border: '1px solid #545454',
      option: {
        focusBorder: '0',
        focusBackground: '#F1F1F1',
      },
    },
  },
  radio: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'NB-form-radio.svg',
      checkedImage: 'form-radio-active.svg',
      hoverImage: 'NB-form-radio-hover.svg',
      errorImage: 'form-radio-error.svg',
      disabledImage: 'NB-form-radio.svg',
    },
    errorMargin: '20px -20px -16px',
    labelFontHeight: '22px',
  },
  errorPage: {
    font: {
      height: '18px',
      portrait: {
        height: '30px',
      },
    },
  },
  inputNote: {
    color: '#545454',
    size: '14px',
    height: '16px',
    marginTop: '8px',
  },
  separator: {
    background: ' #acacac',
    color: '#919191',
    height: '1px',
    fontSize: '14px',
    lineHeight: '16px',
    portraitMargin: '40px 0',
  },
  tab: {
    fontSize: '18px',
    desktop: {
      focusBorder: 'solid 4px #000000',
      bottomMargin: '-4px',
      height: '80px',
    },
    mobile: {
      icon: {
        border: 'solid 2px #ACACAC',
        width: '14px',
        height: '14px',
        color: '#000000',
      },
    },
  },
  shell: {
    header: {
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      color: '#000',
      backgroundColor: '#FFF',
      padding: '18px 20px',
      poweredLogo: {
        src: 'logo-onelog-poweredby-black.png',
      },
      icon: {
        image: 'testing-logo-red.png',
        href: 'https://blick.ch',
      },
      logo: {
        height: {
          default: '48px',
          small: '36px',
          onScroll: '36px',
        },
      },
      languageSwitcher: {
        color: '#000',
        activeColor: '#3c5162',
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '14px',
          lineHeight: '22px',
          color: '#3c5162',
          hoverBackgroundColor: '#cdd5db',
        },
      },
      menu: {
        default: {
          color: '#000000',
          fontSize: '20px',
        },
        active: {
          color: '#FFFFFF',
          backgroundColor: '#3c5162',
          hoverBackgroundColor: '#6E7F8C',
          selectedBackgroundColor: '#4dbab4',
          separatorColor: '#2C3B47',
        },
      },
      boxShadow: '0 2px 4px -2px rgba(0, 0, 0, 0.5)',
      logoMarginRight: {
        default: '0',
        portrait: '0',
      },
    },
    footer: {
      tenants: {
        color: '#3C5162',
        hoverColor: '#2A3D4C',
        backgroundColor: '#ECF0F3',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
      copyright: {
        color: '#cdd5db',
        hoverColor: '#FFF',
        backgroundColor: '#3c5162',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
    },
  },
  consent: {
    checkbox: {
      marginBottom: '8px',
      paddingBottom: '16px',
    },
  },
  address: {
    padding: '0px',
    inputBackgroundColor: '',
    formFieldMarginBottom: '0px',
    checkboxPadding: '20px 20px 16px 20px',
    link: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
}
